var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsentReceived(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65.737 65.737",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.869.9C15.213.9.9 15.213.9 32.869s14.313 31.968 31.969 31.968S64.837 50.525 64.837 32.87 50.525.9 32.87.9zm0 6.187c14.248 0 25.78 11.531 25.78 25.782 0 14.248-11.53 25.78-25.78 25.78-14.249 0-25.782-11.53-25.782-25.78 0-14.249 11.531-25.782 25.782-25.782zM50.942 23.88l-2.905-2.929a1.547 1.547 0 00-2.188-.009L27.63 39.017l-7.708-7.77a1.547 1.547 0 00-2.188-.009l-2.929 2.905a1.547 1.547 0 00-.008 2.188l11.702 11.797c.602.606 1.58.61 2.187.009l22.248-22.07c.607-.601.61-1.58.009-2.187z",
    fill: "#78D64C",
    fillRule: "nonzero",
    stroke: "#3C3C3B",
    strokeWidth: 1.8
  })));
}
export default SvgConsentReceived;